import { Observable } from 'rxjs';

import { Response } from '@shure/shared/angular/data-access/system-api/models';

import { DelayChannel } from '../models';

export abstract class DelayApiService {
	/**
	 * Get channel that supports compressor.
	 */
	public abstract getChannel$(channelId: string): Observable<DelayChannel>;

	/**
	 * Enable/disable delay for channel.
	 */
	public abstract toggleDelay(channelId: string, enabled: boolean): Observable<Response<void, string>>;

	/**
	 * Set delay duration for channel.
	 */
	public abstract setDelayDuration(channelId: string, delay: number): Observable<Response<void, string>>;
}
